import {
    UPDATE_SETTINGS, FETCH_SETTINGS, FETCH_CURRENCY, UPDATE_CURRENCY, FETCH_TIMEZONE, UPDATE_TIMEZONE
} from './actionTypes';

export const fetchSettings = () => ({
    type: FETCH_SETTINGS,
    params: {}
})

export const fetchCurrency = () => ({
    type: FETCH_CURRENCY,
    payload: ""
  });

export const fetchTimezone = () => ({
    type: FETCH_TIMEZONE,
    payload: ""
});

export const updateSettings = (params) => {
    const defaultParams = {
        companyName: "", companyShortName: "", mpesaShortcodeType: "", includeInMessages:false,
        defaultAccountNumber: "", mpesaShortcode:"", tillNumber: "",
        validatePayments:true, autoGenerateRentInvoices: false, autoGenerateOtherRecurringInvoices: false, alertLandlordNewTenant: false,
        address: "", logo:null, updateLogo:false, letterhead: null, updateLetterhead: false, tenantPaymentReminderDates: [], leaseSmsAlertDays: [], 
        accountType: "", messageTypes: []
    };
    const combinedParams = { ...defaultParams, ...params};
    return ({
        type: UPDATE_SETTINGS,
        payload: {
            ...combinedParams
        },
        errors: null
    });
}

export const updateCurrency = (newCurrency) => {
    return {
      type: UPDATE_CURRENCY,
      payload: { customerCurrency: newCurrency },
      errors: null
    };
  };

export const updateTimezone = (newTimezone) => {
return {
    type: UPDATE_TIMEZONE,
    payload: { customerTimezone: newTimezone },
    errors: null
};
};